<template>
  <label
    class="BSCCheckbox"
    ref="label"
    @keydown.prevent.enter="$refs.label.click()"
  >
    <input
      class="BSCCheckbox-input"
      :class="classType"
      v-model="computedValue"
      :indeterminate.prop="indeterminate"
      type="checkbox"
      @click.stop
      :required="required"
      :name="name"
      :value="newValue"
      :disabled="disabled"
      :true-value="trueValue"
      :false-value="falseValue"
    />
    <div class="BSCCheckbox-label">
      <slot />
    </div>
  </label>
</template>

<script>
'use strict'

export default {
  name: 'BSCCheckbox',
  props: {
    value: [String, Number, Boolean, Function, Object, Array, Symbol],
    indeterminate: Boolean,
    type: String,
    required: Boolean,
    name: String,
    size: String,
    disabled: Boolean,
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: false
    }
  },
  data() {
    return {
      newValue: this.value
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.newValue
      },
      set(value) {
        this.newValue = value
        this.$emit('input', value)
      }
    },
    classType() {
      return [
        `is-${this.type}`,
        { 'is-selected': this.newValue === this.trueValue }
      ]
    }
  },
  watch: {
    value(newValue) {
      this.newValue = newValue
    }
  }
}
</script>

<style lang="scss">
.BSCCheckbox {
  &-input {
    &:checked {
      &:before {
        content: '';
        background: url('./assets/check.svg') no-repeat transparent;
        background-size: 10px;
        background-position: 50% 50%;
        background-size: 12px;
      }
    }
  }
}
</style>
